const shouldHaveContent = (warns, content, location) => {
    if (!content)
        warns.push({
            message: `Missing content.`,
            location,
        });
};
const maxLength = (warns, content, location) => {
    if (content.length > 255)
        warns.push({
            message: `Content too long (over 255 characters).`,
            location,
        });
};
const authorFormat = (warns, content, location) => {
    if (!content)
        return;
    const commas = [...content.trim().matchAll(/,/g)].length;
    const hasSpaceButNoCommas = content.includes(" ")
        && commas === 0;
    const hasTooManyCommas = commas > 2;
    if (hasSpaceButNoCommas || hasTooManyCommas)
        warns.push({
            message: "Authors should be formated as: Lastname, Firstname, Suffix",
            location,
        });
};
const tagValidations = {
    'FAU': [
        shouldHaveContent,
        maxLength,
        authorFormat,
    ]
};
export const runValidationsFor = (tag, warns, content, location) => { var _a; return (_a = tagValidations[tag]) === null || _a === void 0 ? void 0 : _a.forEach(tv => tv(warns, content, location)); };
